import { useMemo } from 'react';
import { CatalogTreeRootInput } from '@graphql/generated-base';
import { useCatalogCurationsTreeRootQuery } from '@graphql/queries/catalog.curations.graphql.generated';
import type { CatalogCurationDictionaryEntry } from '../../state/Catalog/Catalog.types';
import { useShopStorefrontContext } from '../../components/ShopStorefrontProvider';

export const useCurationsTree = () => {
  const { currentStorefront } = useShopStorefrontContext();
  const { data, loading, error } = useCatalogCurationsTreeRootQuery({
    batchMode: 'fast',
    variables: { types: [CatalogTreeRootInput.curations], storefront: currentStorefront },
  });
  const treeRoot = data?.productCatalogCategoryTreeRoot;

  const { curationsDictionary } = useMemo(() => {
    const dictionary: Record<string, CatalogCurationDictionaryEntry> = {};
    if (treeRoot) {
      treeRoot.children.forEach(curation => {
        dictionary[curation.publicUrlPath] = { ...curation, lineageCsp: [treeRoot] };
      });
    }
    return { curationsDictionary: dictionary };
  }, [treeRoot]);

  return {
    treeRoot,
    curationsDictionary,
    isLoadingTreeRootData: loading,
    error,
  } as const;
};
